module.exports = __webpack_public_path__ + "img/Logo_Brno_Unesco-300x130.9eb6118c.png";